import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { CHART_COLORS } from '@/utils/statisticsFormatters';
import { CustomTooltip } from './CustomTooltip';

interface ActivityChartProps {
  conversations: { date: string; count: number }[];
  documents: { date: string; count: number }[];
  casos?: { date: string; count: number }[];
}

export const ActivityChart = ({ conversations, documents, casos }: ActivityChartProps) => {
  // Combinar dados
  const allDates = new Set([
    ...conversations.map(c => c.date),
    ...documents.map(d => d.date),
    ...(casos?.map(c => c.date) || []),
  ]);

  const combinedData = Array.from(allDates).map(date => ({
    date,
    conversas: conversations.find(c => c.date === date)?.count || 0,
    documentos: documents.find(d => d.date === date)?.count || 0,
    casos: casos?.find(c => c.date === date)?.count || 0,
  })).sort((a, b) => a.date.localeCompare(b.date));

  const chartConfig = {
    conversas: {
      label: 'Conversas',
      color: 'hsl(142.1 76.2% 36.3%)',
    },
    documentos: {
      label: 'Documentos',
      color: 'hsl(262.1 83.3% 57.8%)',
    },
    casos: {
      label: 'Casos',
      color: 'hsl(221.2 83.2% 53.3%)',
    },
  };

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={combinedData}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => {
              const date = new Date(value);
              return `${date.getDate()}/${date.getMonth() + 1}`;
            }}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="conversas" fill={CHART_COLORS.success} radius={[4, 4, 0, 0]} animationDuration={600} />
          <Bar dataKey="documentos" fill={CHART_COLORS.purple} radius={[4, 4, 0, 0]} animationDuration={600} />
          {casos && <Bar dataKey="casos" fill={CHART_COLORS.warning} radius={[4, 4, 0, 0]} animationDuration={600} />}
        </BarChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
